import React, { useState, useEffect } from 'react';

const MESSAGES = {
  generate: [
    [0,  30, ['Sit tight, we\u2019re cooking your videos.', 'Good things take a few seconds.']],
    [30, 80, ['Good time to grab a coffee.', 'Go check your mail, we\u2019ve got this.', 'Your videos are taking shape.']],
    [80, 99, ['Almost ready.', 'Final touches in progress.', 'Just a moment more.']],
  ],
  export: [
    [0,  30, ['Timbo is packing your order, get ready!', 'Preparing your files\u2026']],
    [30, 80, ['Downloading and saving\u2026', 'Almost packed!']],
    [80, 99, ['Final files coming in\u2026', 'Just a moment more.']],
  ],
};

function getMessage(type, pct, idx) {
  const msgs = MESSAGES[type] || MESSAGES.generate;
  for (const [lo, hi, list] of msgs) {
    if (pct >= lo && pct < hi) return list[idx % list.length];
  }
  return 'Almost ready.';
}

export default function ProgressRail({ done, total, error, type, onAction, onRetry }) {
  const [msgIdx, setMsgIdx] = useState(0);
  const pct = total > 0 ? Math.min(Math.round((done / total) * 100), 100) : 0;
  const finished = done >= total && total > 0 && !error;
  const hasError = !!error;
  const isExport = type === 'export';

  useEffect(() => {
    if (finished || hasError) return;
    const t = setInterval(() => setMsgIdx(i => i + 1), 3000);
    return () => clearInterval(t);
  }, [finished, hasError]);

  const bg = hasError ? '#e53935' : finished ? '#22c55e' : '#F97316';
  const unit = isExport ? 'video' : 'remix';
  const units = (total !== 1) ? unit + (isExport ? 's' : 'es') : unit;

  const titleText = hasError
    ? '\u2717 ' + (total - done) + ' of ' + total + ' failed'
    : finished
      ? '\u2713 ' + total + ' ' + units + (isExport ? ' exported' : ' ready')
      : (isExport ? 'Exporting ' : 'Generating ') + total + ' ' + units + '\u2026';

  const subText = hasError
    ? error
    : finished
      ? (isExport ? 'Saved to your folder' : 'Go to export \u2192')
      : getMessage(type || 'generate', pct, msgIdx);

  return (
    <div style={{
      position: 'relative', width: '100%', height: 52, borderRadius: 8,
      background: bg, overflow: 'hidden', display: 'flex',
      alignItems: 'center', justifyContent: 'space-between',
      padding: '0 20px', transition: 'background .4s',
      cursor: (finished && !isExport) ? 'pointer' : 'default',
    }} onClick={(finished && !isExport) ? onAction : undefined}>
      {!finished && !hasError && (
        <div style={{
          position: 'absolute', top: 0, right: 0, height: '100%',
          width: (100 - pct) + '%', background: 'rgba(0,0,0,.12)',
          transition: 'width .5s cubic-bezier(.4,0,.2,1)', pointerEvents: 'none',
        }} />
      )}
      <div style={{ position: 'relative', display: 'flex', alignItems: 'center', gap: 14, zIndex: 1 }}>
        <span style={{ fontSize: 14, fontWeight: 500, color: '#fff', fontFamily: "'DM Sans', sans-serif", whiteSpace: 'nowrap' }}>
          {titleText}
        </span>
        <div style={{ width: 1, height: 20, background: 'rgba(255,255,255,.35)', flexShrink: 0 }} />
        <span style={{
          fontSize: 12, fontFamily: "'DM Sans', sans-serif",
          color: (hasError || finished) ? '#fff' : 'rgba(255,255,255,.85)',
          fontStyle: (!hasError && !finished) ? 'italic' : 'normal',
        }}>
          {subText}
        </span>
      </div>
      <span style={{ position: 'relative', fontSize: 12, color: 'rgba(255,255,255,.9)', fontFamily: "'DM Sans', sans-serif", zIndex: 1 }}>
        {hasError ? (
          <span onClick={e => { e.stopPropagation(); onRetry && onRetry(); }} style={{
            background: 'rgba(255,255,255,.2)', padding: '4px 12px',
            borderRadius: 6, cursor: 'pointer', fontWeight: 500,
          }}>Retry</span>
        ) : (
          done + ' of ' + total + ' done'
        )}
      </span>
    </div>
  );
}
